import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses localStorage

import dataReducer from "./dataReducer";
import regionReducer from "./regionReducer";
import userReducer from "./userReducer";
import cartReducer from "./cartReducer";
import cartCountReducer from "./cartCountReducer";
import seoReducer from "./seoReducer";
import { RESET_STORE, LOGOUT } from "../actions";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user_data", "cart_data"], // Specify reducers to persist
  transforms: [],
};

// Combine all reducers
const appReducer = combineReducers({
  data: dataReducer,
  region: regionReducer,
  user_data: userReducer,
  cart_data: cartReducer,
  cart_count: cartCountReducer,
  seo_data: seoReducer,
});
// Root reducer with RESET_STORE functionality
const rootReducer = (state, action) => {
  if (action.type === RESET_STORE || action.type === LOGOUT) {
    // storage.removeItem("persist:root"); // Clear persisted Redux state
    return undefined;
    //return appReducer(undefined, action); // Reset state
  }
  return appReducer(state, action);
};

export default persistReducer(persistConfig, rootReducer);
